export const CONTACTS_QUERY_KEYS = {
  GET_CONTACTS: 'GET_CONTACTS',
  CREATE_CONTACT: 'CREATE_CONTACT',
  DELETE_CONTACT: 'DELETE_CONTACT',
  UPDATE_CONTACT: 'UPDATE_CONTACT',
};
